appRun.$inject = ['$rootScope', '$window', '$state', '$transitions','SessionService','$location'];

function appRun($rootScope, $window, $state, $transitions, SessionService,$location){
  $rootScope.reloadProyect = false;
  $rootScope.reloadProyectState = '';
  $transitions.onSuccess({ to: 'home.**' }, function(trans1, trans) {
    
    // esto valida que el usuario este logueado ======

    SessionService.getGlobals().then(globals => {
        let authPages = ["home","categories","reportes","users","shop",
        "products","canasta","compra-rapida","orders","plantillas","account"];
        let searchPath;
        let term = $location.url();
        let flagPath = false;
        $.each(authPages, function (key, queryVal) {
          searchPath = term.search(queryVal)
          if(searchPath > 0){
            flagPath = true;
          }
        });
        
        if(term == "/"){
          $state.go('home.landing');
        }
        
        if(flagPath){
            if(globals.currentUser === null){
              $state.go('home.landing');
            }
        }
          
      })
      
    //===================================================

    $("html, body").stop().animate({scrollTop:0}, 200, 'swing');

    if($rootScope.reloadProyect){
      $rootScope.reloadProyect = false;
      $state.go($rootScope.reloadProyectState);
      // $timeout(() => {
      //   $state.reload();
      // }, 1000);
    }
  });
}

export default appRun;



/** WEBPACK FOOTER **
 ** ./www/components/app.run.js
 **/